import { DeleteButton, SaveButton, Toolbar, useRecordContext } from 'react-admin'

const RetailerAddressEditToolbar = (props: any) => {
    const record = useRecordContext()

    return (
        <Toolbar
            {...props}
            sx={{
                '& .RaToolbar-defaultToolbar': {
                    justifyContent: 'space-between'
                }
            }}
        >
            <SaveButton />
            <DeleteButton redirect={`/Retailer/${record?.retailer_id}/addresses`} />
        </Toolbar>
    )
}

export default RetailerAddressEditToolbar
